export const API_PATH = '/api/backend/';
export const BACKEND_BASE_URL = process.env.REACT_APP_BASE_URL + API_PATH;

export const LOGIN_URL = `${BACKEND_BASE_URL}o/token/`;
export const USER_PROFILE_URL = `${BACKEND_BASE_URL}users/me/`;
export const BACKEND_CLIENT_ID = 'it.netfarm.riot';
export const BACKEND_GRANT_TYPE = 'password';

export const DEVICESETS_URL = `${BACKEND_BASE_URL}devicesets/geo/`;
export const DEVICES_URL = `${BACKEND_BASE_URL}devices/geo/`;
